// removed by extract-text-webpack-plugin
module.exports = {"AccountBar":"eqxbRIEs4c0nycpSx-zI4","AccountBar__profile":"F17L26QoKQ4670U2-kQyw","AccountBar__user-icon":"_1EHswf876V8i82MAy1fjRL","AccountBar__mini-profile":"_2I5L5CE3JKHmVJSpIkf6_3","AccountBar__mini-profile-angle":"_2iCTP8fZQy1wZw5CPS-E29","AccountBar__mini-profile--open":"_3e7FlUP7kcXxcao1sZVoTm"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AccountBar/AccountBar.scss
// module id = 2451
// module chunks = 0